"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Table: true
};
exports.default = exports.Table = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _Table = _interopRequireDefault(require("./Table"));
var _LocaleContext = require("../locales/LocaleContext");
var _default2 = _interopRequireDefault(require("../locales/default"));
var _interface = require("./interface");
Object.keys(_interface).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _interface[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interface[key];
    }
  });
});
var _PlaceholderView = _interopRequireDefault(require("./components/PlaceholderView"));
var _EmptyView = _interopRequireDefault(require("./components/EmptyView"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _Column = _interopRequireDefault(require("./Column"));
var _ColumnGroup = _interopRequireDefault(require("./ColumnGroup"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Table properties.
 */

/**
 * Table
 */
var Table = exports.Table = function Table(props) {
  return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/React.createElement(_LocaleContext.LocaleReceiver, {
      componentName: "Table",
      defaultLocale: _default2.default.Table
    }, function (localeCode, locale) {
      return /*#__PURE__*/React.createElement(_Table.default, (0, _extends2.default)({
        locale: locale,
        theme: theme
      }, props));
    });
  });
};
Table.Column = _Column.default;
Table.ColumnGroup = _ColumnGroup.default;
Table.PlaceholderView = _PlaceholderView.default;
Table.EmptyView = _EmptyView.default;
var _default = exports.default = Table;